import { useApp } from "../app/AppContext";

export function TimerChip() {
  const { timer, openFocus } = useApp();
  const mm = String(Math.floor(timer.left / 60)).padStart(2, "0");
  const ss = String(timer.left % 60).padStart(2, "0");
  return (
    <button
      className={`timerchip${timer.running ? " run" : ""}`}
      onClick={() => openFocus()}
      title="Focus timer (f)"
    >
      <span>◷</span>
      <span>{timer.running ? `${mm}:${ss}` : "Focus"}</span>
    </button>
  );
}
